/**
 * Helpers for transforming API/raw data into { label, value } dropdown format
 */

/**
 * Converts a simple value to { label, value }.
 * @param {*} value - The value (used for both label and value if no transform)
 * @param {Function} [labelTransform] - Optional fn to transform label (e.g. v => v.toUpperCase())
 * @returns {{ label: *, value: * } | null} - Returns null if value is null/undefined
 */
export function toLabelValue(value, labelTransform) {
  if (value == null) return null;
  const label = typeof labelTransform === "function" ? labelTransform(value) : value;
  return { label, value };
}

/**
 * Finds an item in a list by id and maps it to { label, value }.
 * @param {Array} list - Source array (e.g. taxCodeList, accessRuleList)
 * @param {string} id - Id to match (e.g. _id)
 * @param {Object} [options] - Mapping options
 * @param {string} [options.idKey='_id'] - Property to match against id
 * @param {string} [options.labelKey] - Property to use as label (e.g. 'taxCode', 'name')
 * @param {Function} [options.labelTransform] - Optional fn to transform label (e.g. v => v.toUpperCase())
 * @param {string} [options.valueKey='_id'] - Property to use as value
 * @returns {{ label: *, value: * } | null} - Returns null if not found
 */
export function findToLabelValue(list, id, options = {}) {
  if (!Array.isArray(list) || id == null) return null;
  const {
    idKey = "_id",
    labelKey = "name",
    labelTransform,
    valueKey = "_id",
  } = options;
  const item = list.find((obj) => obj[idKey] === id);
  if (!item) return null;
  const value = item[valueKey];
  let label = labelKey ? item[labelKey] : item;
  if (typeof labelTransform === "function") {
    label = labelTransform(label);
  }
  return { label, value };
}
